//export class RoleProjectJobNumberListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleProjectJobNumberListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RoleProjectJobNumberDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RoleProjectJobNumberEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleProjectJobNumber/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RoleProjectJobNumberFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public roleId: IFieldOptions = { field: "roleId" };
	public projectNumberId: IFieldOptions = { field: "projectNumberId" };
	public exclude: IFieldOptions = { field: "exclude" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.projectNumberId);
		this.push(this.exclude);
	}
}

export class RoleProjectJobNumberForm implements IFormOptions {
	protected roleProjectJobNumberFormName: string = "roleProjectJobNumberForm";
	protected roleProjectJobNumberFormModel: models.RoleProjectJobNumberDTO = new models.RoleProjectJobNumberDTO();
	protected roleProjectJobNumberFormEndPoints: RoleProjectJobNumberEndPoints = new RoleProjectJobNumberEndPoints();
	protected roleProjectJobNumberFormFields: RoleProjectJobNumberFormFields = new RoleProjectJobNumberFormFields();
	public get name(): string { return this.roleProjectJobNumberFormName };
	public get model(): models.RoleProjectJobNumberDTO { return this.roleProjectJobNumberFormModel };
	public get endPoints(): IEntityEndPoints { return this.roleProjectJobNumberFormEndPoints };
       public set endPoints(roleProjectJobNumberEndPoints: IEntityEndPoints) {
		this.roleProjectJobNumberFormEndPoints = roleProjectJobNumberEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RoleProjectJobNumberFormFields { return this.roleProjectJobNumberFormFields };
}

export class RoleProjectJobNumberListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public roleId: IColumnOptions = { field: "roleId" };
	public projectNumberId: IColumnOptions = { field: "projectNumberId" };
	public exclude: IColumnOptions = { field: "exclude" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.projectNumberId);
		this.push(this.exclude);
	}
}

export class RoleProjectJobNumberList implements IGridOptions {
	protected roleProjectJobNumberListName: string = "roleProjectJobNumberList";
	protected roleProjectJobNumberListModel: models.RoleProjectJobNumberDTO = new models.RoleProjectJobNumberDTO();
	protected roleProjectJobNumberListEndPoints: RoleProjectJobNumberEndPoints = new RoleProjectJobNumberEndPoints();
	protected roleProjectJobNumberListColumns: RoleProjectJobNumberListColumns = new RoleProjectJobNumberListColumns();
	public roleProjectJobNumberForm: RoleProjectJobNumberForm = new RoleProjectJobNumberForm();
	public get name(): string { return this.roleProjectJobNumberListName };
	public get model(): models.RoleProjectJobNumberDTO { return this.roleProjectJobNumberListModel };
	public get endPoints(): IEntityEndPoints { return this.roleProjectJobNumberListEndPoints };
	public set endPoints(roleProjectJobNumberEndPoints: IEntityEndPoints) {
		this.roleProjectJobNumberListEndPoints = roleProjectJobNumberEndPoints;
		this.roleProjectJobNumberForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RoleProjectJobNumberListColumns { return this.roleProjectJobNumberListColumns };
}

export class RoleProjectJobNumberEntity implements IEntityOptions {
	protected roleProjectJobNumberEntityName: string = "roleProjectJobNumberEntity";
	protected roleProjectJobNumberEntityModel: models.RoleProjectJobNumberDTO = new models.RoleProjectJobNumberDTO();
	protected roleProjectJobNumberEntityEndPoints: RoleProjectJobNumberEndPoints = new RoleProjectJobNumberEndPoints();
	protected roleProjectJobNumberEntityList: RoleProjectJobNumberList = new RoleProjectJobNumberList();
	public get name(): string { return this.roleProjectJobNumberEntityName };
	public get model(): models.RoleProjectJobNumberDTO { return this.roleProjectJobNumberEntityModel };
	public get endPoints(): IEntityEndPoints { return this.roleProjectJobNumberEntityEndPoints };
	public set endPoints(roleProjectJobNumberEndPoints: IEntityEndPoints) {
		this.roleProjectJobNumberEntityEndPoints = roleProjectJobNumberEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RoleProjectJobNumberList { return this.roleProjectJobNumberEntityList };
	public get form(): RoleProjectJobNumberForm { return this.grid.roleProjectJobNumberForm };
	constructor(name?: string) {
		if (name) this.roleProjectJobNumberEntityName = name;
		this.endPoints = this.roleProjectJobNumberEntityEndPoints;
	}
};
//export class RoleProjectJobNumberGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RoleProjectJobNumberForm = new RoleProjectJobNumberForm();
//};

//export class RoleProjectJobNumberListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RoleProjectJobNumberList = new  RoleProjectJobNumberList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleProjectJobNumberBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleProjectJobNumberGeneratedForm}];
//};

